/**
 * /admin/pages — route parent ثابت لمنشئ الصفحات.
 *
 * وجود هذا الملف يمنع شجرة TanStack Router من محاولة تحميل parent مفقود
 * عند استدعاء أي server function من صفحات الأدمن بعد تغييرات HMR.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/pages")({
  component: () => <Outlet />,
  head: () => ({ meta: [{ title: "الصفحات · Admin · Lecmo" }] }),
});